module.exports = __webpack_public_path__ + "../DT/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../DT/[name].[ext]!./configs/appSettings/DT/appsettings.js
// module id = 754
// module chunks = 1